import React from 'react';
import ComprehensiveFooter from '../../MicrospecDynamicUI/Pages/SectionsMapper/Footer/ComprehensiveFooter';
import { ComprehensiveFooterSpec } from '../../MicrospecDynamicUI/Pages/SectionsMapper/Footer/ComprehensiveFooter/types';
import { commonNavLinks } from './commonNavLinks';

const spec: ComprehensiveFooterSpec = {
    navigationLinks: [
        {
            title: 'קישורים מהירים',
            links: commonNavLinks,
        },
    ],
};

const CommonComprehensiveFooter: React.FC = () => {
    return <ComprehensiveFooter spec={spec} />;
};

export default CommonComprehensiveFooter;
